import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { selectChatContactId, selectChatSkillId, selectIsChatAccepted, useChatStore } from 'stores/nic/stores/chatStore';
import { selectAgentSkills, useNicStore } from 'stores/nic/stores/nicStore';
import IncomingChat from './IncomingChat';
import ChatDialog from './ChatDialog';
var ChatView = function () {
    var _a, _b;
    var contactId = useChatStore(selectChatContactId);
    var skillId = useChatStore(selectChatSkillId);
    var isChatAccepted = useChatStore(selectIsChatAccepted);
    var agentSkills = useNicStore(selectAgentSkills);
    if (!contactId)
        return null;
    var skillName = (_b = (_a = agentSkills.find(function (skill) { return String(skill.skillId) === skillId; })) === null || _a === void 0 ? void 0 : _a.skillName) !== null && _b !== void 0 ? _b : null;
    return isChatAccepted ? (_jsx(ChatDialog, { contactId: contactId, skillName: skillName })) : (_jsx(IncomingChat, { contactId: contactId, skillName: skillName }));
};
export default ChatView;
